/**
 * Giant watermark divider — bold typographic break between sections.
 * Theme: "dark" or "light".
 */
export const Watermark = ({ text = "RESPOND", theme = "light" }) => {
    const isDark = theme === "dark";
    return (
        <section
            data-testid={`watermark-${text.toLowerCase()}`}
            className={`relative overflow-hidden py-10 md:py-16 ${
                isDark ? "bg-[#0A1428]" : "bg-white border-y border-slate-200"
            }`}
            aria-hidden="true"
        >
            <div className="relative max-w-[1400px] mx-auto px-6">
                <div
                    className={`reveal font-display font-extrabold leading-[0.85] tracking-[-0.04em] text-center select-none ${
                        isDark ? "text-white/[0.06]" : "text-slate-100"
                    }`}
                    style={{ fontSize: "clamp(96px, 18vw, 280px)" }}
                >
                    {text}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="flex items-center gap-4">
                        <span className="h-2 w-2 rounded-full bg-[#F0493E] animate-pulse" />
                        <span
                            className={`text-[10px] md:text-xs font-bold uppercase tracking-[0.4em] ${
                                isDark ? "text-white" : "text-[#0A1428]"
                            }`}
                        >
                            Every second counts
                        </span>
                        <span className="h-2 w-2 rounded-full bg-[#F0493E] animate-pulse" />
                    </div>
                </div>
            </div>
        </section>
    );
};
